import React from "react";
import { Grid3x3, Database } from "lucide-react";
import DynamicAgGrid from "./AgDynamicTable/AgDynamicTable";

const TableView = ({ response, loading = false, theme = "light" }) => {
  const isDark = theme === "dark";
  const rows = response?.data?.rows || [];

  if (loading) {
    return (
      <div className={`flex h-full items-center justify-center rounded-2xl border p-6 ${isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"}`}>
        <img src="/chat/thinking.gif" alt="Loading" className="h-20 w-20" />
      </div>
    );
  }
  if (!response) {
    return (
      <div className={`flex h-full flex-col items-center justify-center rounded-2xl border border-dashed p-6 text-center ${isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"}`}>
        <div className={`flex h-12 w-12 items-center justify-center rounded-2xl ${isDark ? "bg-slate-800 text-slate-400" : "bg-slate-100 text-slate-500"}`}>
          <Grid3x3 size={20} />
        </div>
        <div className={`mt-3 text-sm font-semibold ${isDark ? "text-slate-200" : "text-slate-700"}`}>Get Started Your Analysis !</div>
        <div className={`text-xs ${isDark ? "text-slate-500" : "text-slate-500"}`}>Ask a question to generate the best tabular report.</div>
      </div>
    );
  }

  if (!rows.length) {
    return (
      <div className={`flex h-full flex-col items-center justify-center rounded-2xl border border-dashed p-6 text-center ${isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"}`}>
        <div className={`flex h-12 w-12 items-center justify-center rounded-2xl ${isDark ? "bg-slate-800 text-slate-400" : "bg-slate-100 text-slate-500"}`}>
          <Grid3x3 size={20} />
        </div>
        <div className={`mt-3 text-sm font-semibold ${isDark ? "text-slate-200" : "text-slate-700"}`}>Tabular View Not Applicable !</div>
        <div className={`text-xs ${isDark ? "text-slate-500" : "text-slate-500"}`}>This query doesn't have a suitable tabular report.</div>
      </div>
    );
  }

  return (
    <div className={`h-full rounded-2xl border p-3 shadow-sm ${isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"}`}>
      <DynamicAgGrid response={response} height="100%" theme={theme} />
    </div>
  );
};

export default TableView;
